// AlertService.jsx
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Zoom from '@mui/material/Zoom';
let showAlertFn; // singleton reference

export function showAlert(text) {
  if (showAlertFn) showAlertFn(text);
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return (
    <Zoom
      ref={ref}
      timeout={600} // speed (ms)
      {...props}
    />
  );
});

export default function AlertService() {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');

  useEffect(() => {
    showAlertFn = (message) => {
      setText(message);
      setOpen(true);
    };
    return () => {
      showAlertFn = null;
    };
  }, []);

  const handleClose = () => setOpen(false);

  return ReactDOM.createPortal(
    <Dialog
      open={open}
      slots={{
        transition: Transition,
      }}
      onClose={handleClose}
      fullWidth
      maxWidth='sm'
    >
      <DialogTitle>Alert !</DialogTitle>
      <DialogContent>
        {/* Use dangerouslySetInnerHTML to render HTML content */}
        <DialogContentText
          component='div'
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>,
    document.body,
  );
}
